<template>
    <v-card>
        <div class="LoaderWrapper"
             :class="{jsHidden:loaded}"
        >
            <v-progress-linear indeterminate color="primary"/>
        </div>
        <v-card-title class="CardTitle--big-center">
            Monthly Numbers
            <HelpModal v-if="helpText"
                       :text="helpText"
                       :title="helpTitle"
            ></HelpModal>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="mnHeaders"
                          :items="mnItems"
                          disable-sort
                          disable-pagination
                          hide-default-footer
                          class="FreedomFigureTable"
            >
                <template v-slot:item.month="props">
                    <v-edit-dialog :return-value.sync="props.item.month"
                                   @save="save(props.item)"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                                   class="TableEditDialog"
                    >
                        {{ translateMonth(props.item.month) }}
                        <template v-slot:input>
                            <v-select :items="months"
                                      v-model="props.item.month"
                                      item-text="text"
                                      item-value="value"
                                      default="default"
                                      outlined
                                      placeholder="Select Month"
                                      label="Select Month"
                            ></v-select>
                        </template>
                    </v-edit-dialog>
                </template>

                <template v-slot:item.visits="props">
                    <v-edit-dialog :return-value.sync="props.item.visits"
                                   @save="save(props.item)"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ props.item.visits === 0 ? '' : formatNumber(props.item.visits) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.visits"
                                          outlined
                                          type='number'
                                          label="Visits"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
                <template v-slot:item.booked_calls="props">
                    <v-edit-dialog :return-value.sync="props.item.booked_calls"
                                   @save="save(props.item)"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ props.item.booked_calls === 0 ? '' : formatNumber(props.item.booked_calls) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.booked_calls"
                                          outlined
                                          type="number"
                                          label="Booked Calls"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
                <template v-slot:item.held_calls="props">
                    <v-edit-dialog :return-value.sync="props.item.held_calls"
                                   @save="save(props.item)"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ props.item.held_calls === 0 ? '' : formatNumber(props.item.held_calls) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.held_calls"
                                          outlined
                                          type="number"
                                          label="Held Calls"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
                <template v-slot:item.closed_calls="props">
                    <v-edit-dialog :return-value.sync="props.item.closed_calls"
                                   @save="save(props.item)"
                                   @cancel="cancel"
                                   @open="open"
                                   @close="close"
                                   large
                    >
                        {{ props.item.closed_calls === 0 ? '' : formatNumber(props.item.closed_calls) }}
                        <template v-slot:input>
                            <v-text-field v-model="props.item.closed_calls"
                                          outlined
                                          type="number"
                                          label="Closed Calls"
                                          :rules="[rules.isNumber]"
                            >
                            </v-text-field>
                        </template>
                    </v-edit-dialog>
                </template>
                <template v-slot:item.booked_visits="props">
                    {{
                        formatConversionPercentage(props.item.booked_calls, props.item.visits)
                    }}
                </template>
                <template v-slot:item.held_booked="props">
                    {{
                        formatConversionPercentage(props.item.held_calls, props.item.booked_calls)
                    }}
                </template>
                <template v-slot:item.closed_held="props">
                    {{
                        formatConversionPercentage(props.item.closed_calls, props.item.held_calls)
                    }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<!--suppress JSStringConcatenationToES6Template -->
<script>
import axios from 'axios';
import store from '@/store/store';
import HelpModal from '@/components/HelpModal';
import freedomFigureMixin from '@/views/Public/Card/freedomFigureMixin';

export default {
    mixins: [ freedomFigureMixin ],
    components: { HelpModal },

    computed: {
        helpTitle() {
            return store.state[this.namespace].helpTitle;
        },

        helpText() {
            return store.state[this.namespace].helpText;
        }
    },

    props: [
        'name',
        'namespace'
    ],

    data() {
        return {
            loaded: true,
            id: null,
        };
    },

    mounted() {
        this.getNumbers();
    },

    methods: {
        getNumbers() {
            this.loaded = false;
            axios.get('/api/freedom-figure-monthly/user')
                .then(response => {
                    this.monthlyNumbers = response.data.data.freedomFigureMonthlyNumbers;
                    this.mnItems = this.monthlyNumbers;
                    this.loaded = true;
                })
                .catch(error => {
                    console.error(error);
                    this.loaded = true;
                });
        },

        save($item) {

            const postData = {
                'month': $item.month ? $item.month : 0,
                'visits': $item.visits ? $item.visits : 0,
                'booked_calls': $item.booked_calls ? $item.booked_calls : 0,
                'held_calls': $item.held_calls ? $item.held_calls : 0,
                'closed_calls': $item.closed_calls ? $item.closed_calls : 0
            };

            axios.post('/api/freedom-figure-monthly/edit/' + $item.id, postData)
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        cancel() {},
        open() {},
        close() {},
    }
};
</script>
